<template>
  <div class="pa-storybook-navigator-wrapper">
    <transition name="storybook-navigator" @enter="handleEnter" @afterEnter="handleAfterEnter">
      <div class="navigator-wrapper" v-if="isOpen">
        <ul class="main-navigator">
          <li @click.prevent="handleChapterButton" :class="chapterButtonClass">章</li>
          <li @click.prevent="handleDownButton"    :class="downButtonClass">▼</li>
          <li @click.prevent="handleUpButton"      :class="upButtonClass">▲</li>
          <li @click.prevent="handleCloseButton"   :class="closeButtonClass">閉</li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props : {
    isOpen : {
      default: false
    }
  },

  data(){
    return {
      isActiveUpButton      : false,
      isActiveDownButton    : false,

      isActiveChapterButton : false,
      isActiveCloseButton   : false, 
      
      chapterButtonClass : {
        'button-active' : true
      },

      downButtonClass : {
        'button-active' : false
      },

      upButtonClass   : {
        'button-active' : false
      },

      closeButtonClass : {
        'button-active' : true
      }
    }
  },

  computed : {
    isOpenTitile(){
      return this.$store.state.storyBook.isOpenStoryTitle;
    },

    paginate(){
      return this.$store.state.storyBook.paginate;
    },

    couldScroll(){
      return this.$store.state.storyBook.couldScroll;
    }
  },

  watch : {
    paginate : {
      handler(){
        this.setButtonStatus();
      },
      deep: true
    },

    couldScroll : {
      handler(){
        this.setButtonStatus();
      },
      deep: true
    },

    isActiveUpButton : {
      handler(value){
        this.upButtonClass['button-active'] = value;
      },
      immediate: true
    },

    isActiveDownButton : {
      handler(value){
        this.downButtonClass['button-active'] = value;
      },
      immediate: true
    },
  },

  methods : {
    setButtonStatus(){
      if(typeof this.paginate === 'undefined') return;
      if(typeof this.couldScroll === 'undefined') return;

      if( (this.couldScroll.up === true) || (this.paginate.prev === true) ){
        this.isActiveUpButton = true;
      }else{
        this.isActiveUpButton = false;
      }

      if( (this.couldScroll.down === true) || (this.paginate.next === true) ){
        this.isActiveDownButton = true;
      }else{
        this.isActiveDownButton = false;
      }
    },

    handleEnter(){
      this.setButtonStatus();
    },

    handleAfterEnter(){
      this.setButtonStatus();
    },

    handleChapterButton(){
      this.$store.dispatch({
        type  : 'storyBook/updateIsOpenStoryTitle',
        value : !this.isOpenTitile
      });
    },

    handleUpButton(){
      this.$parent.$emit('pageScrollUp');
    },

    handleDownButton(){
      this.$parent.$emit('pageScrollDown');
    },

    handleCloseButton(){
      this.$store.dispatch({
        type  : 'storyBook/updateIsOpenStoryModal',
        value : false
      });
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/mixins.scss";

.storybook-navigator{
  &-enter-active{
    opacity: 1;
    transition: opacity 1s;
  }

  &-leave-active{
    transition: opacity 1s;
  }

  &-enter, &-leave-to{
    opacity: 0;
  }
}

.pa-storybook-navigator-wrapper{
  width:100vw;
  position: fixed;
  left: 0;
  bottom:0;
  z-index:1002;

  .navigator-wrapper{
    padding-top:5px;
    background: radial-gradient($golden-box-border-shiny, $golden-box-border);

    ul.main-navigator{
      width:100%;
      height:50px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      background-color: #D3C299;
      color:#C9B68B;

      .button-active{
        color:#726446;
        transition: color .5s;
      }

      li{
        font-size:2rem;
        line-height: 50px;
        user-select: none;

        &:nth-child(1){
          box-sizing: border-box;
          width:16%;
          border-right:2px solid #d2bd9a;
        }

        &:nth-child(2){
          width:34%;
          border-radius:0 0 0 6px;
          transition: color .5s;
        }

        &:nth-child(3){
          box-sizing: border-box;
          width:34%;
          border-radius:0 0 6px 0;
          transition: color .5s;
          border-left:1px solid #D4C297;
        }

        &:nth-child(4){
          box-sizing: border-box;
          width:16%;
          border-left:2px solid #d2bd9a;
        }
      }
    }
  }
}
</style>